module.exports = __webpack_public_path__ + "img/img2.37657517.svg";